module.exports = __webpack_public_path__ + "img/ionibowcher.8032c5a5.png";